const CalendarEventTypesKey = () => {
  return (
    <>
      <span>
        Events{" "}
        <span className="ms-1" style={{ color: "orange", fontSize: "30px" }}>
          ■
        </span>
      </span>
      <span className="ms-5">
        User Tasks{" "}
        <span className="ms-1" style={{ color: "green", fontSize: "30px" }}>
          ■
        </span>
      </span>
      <span className="ms-5">
        Meetings{" "}
        <span className="ms-1" style={{ color: "#265985", fontSize: "30px" }}>
          ■
        </span>
      </span>
    </>
  );
};

export default CalendarEventTypesKey;
